import { Link } from 'react-router-dom';
import type { Technician } from '@/types/customer';
import { services } from '@/mocks/services';
import ExposureResolve from '@/components/base/ExposureResolve';

export default function TechnicianCard({ tech }: { tech: Technician }) {
  const cats = services.filter((s) => tech.serviceSlugs.includes(s.slug)).map((s) => s.short);
  return (
    <article className="group">
      <Link to={`/technicians/${tech.slug}`} className="block">
        <ExposureResolve className="relative h-[420px] md:h-[460px] w-full overflow-hidden rounded-xl bg-primary-50">
          <img src={tech.portrait} width={800} height={1000} loading="lazy" decoding="async" alt={`${tech.name}, ${tech.role}`} title={`${tech.name} - MENDWELL appliance repair`} className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.02]" />
          {tech.isSample && (
            <span className="absolute left-4 top-4 rounded-full bg-white/95 px-3 py-1 text-[11px] uppercase tracking-[0.12em] text-foreground-700">Sample profile</span>
          )}
        </ExposureResolve>
      </Link>
      <div className="border-b border-background-200 pb-6 pt-5">
        <p className="text-[11px] uppercase tracking-[0.16em] text-primary-600">{tech.role}</p>
        <h3 className="mt-2 text-xl font-medium tracking-tight text-foreground-950">{tech.name}</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tech.summary}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {cats.map((c) => (
            <span key={c} className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">{c}</span>
          ))}
        </div>
        <Link to={`/technicians/${tech.slug}`} className="mt-5 inline-flex items-center gap-2 text-sm text-foreground-950 mw-link">
          View Profile <span className="mw-arrow">&rarr;</span>
        </Link>
      </div>
    </article>
  );
}